define("shared/modifiers/show-in-viewport", ["exports", "@ember/debug", "@ember/service", "ember-modifier"], function (_exports, _debug, _service, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug",0,"@ember/service",0,"ember-modifier"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  /**
   *
   * @class ShowInViewportModifier
   * @extends Modifier
   *
   * This handles watching elements in the viewport
   * that will show the targeted element when the provided element(s) are not in viewport
   * and that will hide the targeted element when the provided element(s) are in viewport
   *
   * Positional Parameters:
   * @param {String} watchedIDs The ids of the element(s) to watch the viewport for, can pass in as many as required as separate strings
   * Elements need to be on the DOM on first load of page.
   *
   * Simple Usage:
   *
   * ```
   * <div id="wholePage">
   *   <div {{show-in-viewport "formThatNeedsAttention" "termsAndConditionsThatNeedReading"}}>
   *    "scroll down to fill out form!"
   *    {{svg-jar "arrow-down"}}
   *   <div>
   * |
   * | way down the page
   * |
   * v
   *   <form id="formThatNeedsAttention">
   *   </form>
   *   <p id="termsAndConditionsThatNeedReading">
   *   </p>
   * </div>
   * ```
   */
  let ShowInViewportModifier = _exports.default = (_class = class ShowInViewportModifier extends _emberModifier.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "inViewport", _descriptor, this);
    }
    get watchedElements() {
      return [...this.args.positional].map(elementID => document.getElementById(elementID));
    }
    didReceiveArguments() {
      this.setup();
    }
    willDestroy() {
      this.tearDown();
    }
    hideElement() {
      this.element.classList.add('u--hide');
    }
    setup() {
      this.watchedElements.forEach(element => {
        (false && !(element) && (0, _debug.assert)(`Element must be on the DOM on load of page`, element));
        const {
          onEnter,
          onExit
        } = this.inViewport.watchElement(element);
        onEnter(this.hideElement.bind(this));
        onExit(this.showElement.bind(this));
      });
    }
    showElement() {
      this.element.classList.remove('u--hide');
    }
    tearDown() {
      this.watchedElements.forEach(element => this.inViewport.stopWatching(element));
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "inViewport", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
});